import { X, FileText, BookOpen, Scale, Lightbulb } from 'lucide-react'
import type { Artifact } from '../lib/types'
import ReactMarkdown from 'react-markdown'
import rehypeKatex from 'rehype-katex'
import remarkMath from 'remark-math'

interface ArtifactPanelProps {
  artifact: Artifact | null
  onClose: () => void
}

const artifactIcons = {
  outline: FileText,
  scripture: BookOpen,
  refutation: Scale,
  evidence: Lightbulb,
}

export function ArtifactPanel({ artifact, onClose }: ArtifactPanelProps) {
  if (!artifact) return null

  const Icon = artifactIcons[artifact.type] || FileText

  return (
    <div className="fixed right-0 top-0 z-50 h-full w-full max-w-lg border-l border-[hsl(var(--border))] bg-[hsl(var(--bg))] slide-in-right">
      <div className="flex h-full flex-col">
        <div className="flex items-center justify-between border-b border-[hsl(var(--border))] px-5 py-3">
          <div className="flex items-center gap-3">
            <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-[hsl(var(--accent-soft))]">
              <Icon className="h-4 w-4 text-[hsl(var(--accent))]" />
            </div>
            <div>
              <h2 className="text-small font-semibold text-[hsl(var(--fg))]">{artifact.title}</h2>
              <span className="text-caption text-[hsl(var(--fg-muted))] capitalize">{artifact.type}</span>
            </div>
          </div>
          <button onClick={onClose} className="btn btn-ghost btn-icon" aria-label="Close">
            <X className="h-4 w-4" />
          </button>
        </div>

        <div className="flex-1 overflow-y-auto p-5">
          <div className="prose prose-invert prose-sm max-w-none">
            <ReactMarkdown remarkPlugins={[remarkMath]} rehypePlugins={[rehypeKatex]}>
              {artifact.content}
            </ReactMarkdown>
          </div>
        </div>
      </div>
    </div>
  )
}
